import React, { Component } from "react";

export class CompanyDetails extends Component {
  render() {
    return (
      <>
        <section className="usefulLinksContainer">
          <div className="links">
            <p style={{ color: 'white' }}>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block', minWidth: '300px' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                Company:- CIN: U74899GJ1995PTC115515
              </span>
              <span style={{ color: 'white', margin: '0 10px' }}>|</span>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block', minWidth: '300px' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                SEBI Regd No: INZ000192935 (Stock Broker)
              </span>
            </p>
            <p style={{ color: 'white' }}>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                NSE ID : 09217
              </span>
              <span style={{ color: 'white', margin: '0 10px' }}>|</span>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block', minWidth: '150px' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                BSE ID : 0904
              </span>
            </p>
          </div>
        </section>
      </>
    );
  }
}

export default CompanyDetails;
